import Vue from "vue";
import VueRouter from "vue-router";
// import axios from "axios";
// import store from "../store/index";
// import cookie from "vue-cookie";
// import auth from "../middleware/auth";

// import NotFound from "../views/404NotFound.vue"
Vue.use(VueRouter);
const routes = [
    {
        path: "/login",
        name: "login",
        component: () => import("../views/login.vue"),
    },
    {
        path: "/otp_verify",
        name: "otp_verify",
        component: () => import("../views/otp_verify.vue"),
    },
    {
        path: "/creating_card",
        name: "creating_card",
        component: () => import("../views/creating_card.vue"),
    },
    {
        path: "/initialize_profile",
        name: "initialize_profile",
        component: () => import("../views/initialize_profile.vue"),
    },
    {
        path: "/",
        name: "home_layout",
        props: true,
        component: Vue.component('HomeLayout', () => import("../layouts/home.vue")),
        children: [{
            path: "/",
            component: () => import("../views/home_page.vue"),
            name: "home_page"
        },{
            path: "/more",
            component: () => import("../views/more.vue"),
            name: "more"
        },{
            path: "/manage_account",
            component: () => import("../views/manage_account.vue"),
            name: "manage_account"
        },{
            path: "/subscribe",
            component: () => import("../views/subscribe.vue"),
            name: "subscription"
        },
        {
            path: "/update_card",
            name: "update_card",
            component: () => import("../views/update_card.vue"),
        },{
            path: "/contact_book",
            name: "contact_book",
            component: () => import("../views/contact_book.vue"),
        },{
            path: "/import-export",
            name: "import-export",
            component: () => import("../views/import-export.vue"),
        },
        ],
    },
    {
        path: "/card",
        name: "card_layout",
        props: true,
        component: Vue.component('cardLayout', () => import("../layouts/card.vue")),
        children: [
            {
                path: "/card",
                component: () => import("../views/card/preview.vue"),
                name: "card_preview"
            }, {
                path: "/card/profile",
                component: () => import("../views/card/profile.vue"),
                name: "card_profile"
            }, {
                path: "/card/contacts",
                component: () => import("../views/card/contacts.vue"),
                name: "card_contacts"
            },
            {
                path: "/card/business",
                component: () => import("../views/card/business.vue"),
                name: "card_business"
            },
            {
                path: "/card/gallery",
                component: () => import("../views/card/gallery.vue"),
                name: "card_gallery"
            },
            {
                path: "/card/brochure",
                component: () => import("../views/card/brochure.vue"),
                name: "card_brochure"
            },
            {
                path: "/card/analytics",
                component: () => import("../views/card/analytics.vue"),
                name: "card_analytics"
            }, {
                path: "/card/inbox",
                component: () => import("../views/card/inbox.vue"),
                name: "card_inbox"
            },
        ],
    },
    { 
        path: '*',
        name: 'PageNotFound',
        component: () => import('../views/page_not_found.vue') 
    }
];

const router = new VueRouter({
    mode: "history",
    routes,
});

// router.beforeEach(async(to, from, next) => {
//     console.log(store.getters.status);
//     console.log(store.getters.token);
//     console.log(store.getters.subscription);
//     if (
//         to.name !== "Login" &&
//         to.name !== "Forget" &&
//         to.name !== "VerifyPending" &&
//         to.name !== "Register" &&
//         to.name !== "NotFound" &&
//         to.name !== "CardPreview"
//     ) {
//         if (
//             (await store.getters.status) != false ||
//             (await store.getters.token) != ""
//         ) {
//             if (
//                 (await store.getters.subscription) == null &&
//                 to.name == "Subscription"
//             ) {
//                 next();
//             } else if (
//                 (await store.getters.subscription) == null &&
//                 to.name != "Subscription"
//             ) {
//                 next("/subscription");
//             } else {
//                 if ((await store.getters.cid) == "" && to.name != "Card") {
//                     next("/cards");
//                     return;
//                 }
//                 next();
//                 return;
//             }
//         } else {
//             next("/login");
//             return;
//         }
//     } else {
//         next();
//         return;
//     }
// });

export default router;